import { useState } from "react"

import { Flex, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../../Components/Button"
import Icon from "../../../../../Icon"
import { addTypes } from "../../redux/publicApi.thunks"
import TypesDropdown from "./TypesDropdown"

const { Text } = Typography

const AddEventTypeModal = ({ modalType, close, onAddEventTypeSuccess }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { requestResult } = useSelector((state) => state.publicApi)

  const [selectedTypes, setSelectedTypes] = useState([])
  const defaultTypes = modalType?.data?.event_type_options
    ?.filter((el) => el.is_selected)
    .map((el) => el.value)

  const handleAddEventType = () => {
    if (selectedTypes?.length) {
      dispatch(
        addTypes({
          callback_url: modalType?.data?.callback_url,
          event_types: [...defaultTypes, ...selectedTypes]
        })
      )
        .unwrap()
        .then(onAddEventTypeSuccess)
        // The thunk already raised the global error notification; catching here only
        // keeps the rejection from surfacing as an unhandled promise rejection.
        .catch(() => {})
    }
  }

  // useEffect(() => {
  //   if (requestResult) {
  //     if (requestResult === 'addTypes') {
  //       close();
  //     }
  //     props.requestResultReset()
  //   }
  // }, [requestResult])

  return (
    <Modal
      open={modalType?.type === "add_event"}
      onClose={close}
      onCancel={close}
      footer={null}
      centered={true}
      closeIcon={<Icon type="cross_small" />}
      width={400}
      title={"Event type"}
      destroyOnClose
      className="faq-custom-modal"
      classNames={{ content: "clear-bg" }}
    >
      <div>
        <Text>
          Select the event types that apply. You can pick multiple options from the list below.
        </Text>
        <Text strong style={{ display: "block", margin: "14px 0 4px" }}>
          Types
        </Text>
        <div>
          <TypesDropdown
            types={modalType?.data?.event_type_options || []}
            selectedTypes={selectedTypes}
            onTypesChange={setSelectedTypes}
            defaultTypes={defaultTypes}
          />
        </div>

        <Text
          type="secondary"
          style={{ display: "block", margin: "8px 0", letterSpacing: "-0.3px" }}
        >
          After it expires, new signatures will no longer be generated with the old secret.
        </Text>
      </div>
      <Flex gap={12} justify="end" style={{ margin: "40px 0 0" }}>
        <ButtonComponent size="large" onClick={close} block style={{ width: "fit-content" }}>
          {t("Cancel")}
        </ButtonComponent>

        <ButtonComponent
          size="large"
          type="primary"
          onClick={handleAddEventType}
          block
          style={{ width: "fit-content" }}
        >
          {t("Add")}
        </ButtonComponent>
      </Flex>
    </Modal>
  )
}

export default AddEventTypeModal
